'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var _defineProperty = _interopDefault(require('babel-runtime/helpers/defineProperty'));
var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var reduxActions = require('redux-actions');
var R = _interopDefault(require('ramda'));
var snakeCase = _interopDefault(require('lodash.snakecase'));
var camelCase = _interopDefault(require('lodash.camelcase'));
require('isomorphic-fetch');
var merge = _interopDefault(require('lodash.merge'));

var FETCH_PROCESSING = 'FETCH_PROCESSING';
var FETCH_SUCCESS = 'FETCH_SUCCESS';
var FETCH_FAILURE = 'FETCH_FAILURE';

var INITIAL_STATE = {
  loaded: false,
  processing: false
};

// returns an action creator that takes (username, payload) as it's arguments
// the 'meta' field on the returned action holds the username
//
// type alias Type :: String
// type alias Username :: String
// type class Payload a
// type UsernameAction a = { type :: Type, meta :: Username, payload :: Payload a }
// withUsername :: Payload a => Type -> (Username -> a -> UsernameAction a)
var withUsername = function withUsername(type) {
  var payloadFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : R.nthArg(1);
  return reduxActions.createAction(type, payloadFunc, R.identity);
};

var updateStateByUsername = function updateStateByUsername(state, username, update) {
  return merge({}, state, _defineProperty({}, username, update));
};

// from: https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object-by-a-function
var renameBy = R.curry(function (fn, obj) {
  return R.pipe(R.toPairs, R.map(R.adjust(fn, 0)), R.fromPairs)(obj);
});

/* global fetch */
var actionize = R.compose(R.toUpper, R.join('_'), R.map(snakeCase));

var requestActionType = function requestActionType() {
  for (var _len = arguments.length, xs = Array(_len), _key = 0; _key < _len; _key++) {
    xs[_key] = arguments[_key];
  }

  return 'REQUEST_' + actionize(xs);
};

var successActionType = function successActionType() {
  for (var _len2 = arguments.length, xs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    xs[_key2] = arguments[_key2];
  }

  return 'RECEIVE_' + actionize(xs) + '_SUCCESS';
};

var failureActionType = function failureActionType() {
  for (var _len3 = arguments.length, xs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    xs[_key3] = arguments[_key3];
  }

  return 'RECEIVE_' + actionize(xs) + '_FAILURE';
};

var clearActionType = function clearActionType() {
  for (var _len4 = arguments.length, xs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    xs[_key4] = arguments[_key4];
  }

  return 'CLEAR_' + actionize(xs);
};

var getPrefixForEndpoint = function getPrefixForEndpoint(verb, endpoint) {
  return R.propOr(verb, camelCase(verb) + 'Prefix', endpoint);
};

var getUrl = function getUrl(endpoint, verb) {
  return endpoint[camelCase(verb) + 'Url'];
};

var simpleOptions = function simpleOptions() {
  return {};
};

var getMakeOptions = function getMakeOptions(endpoint, verb) {
  return endpoint[camelCase(verb) + 'Options'] || simpleOptions;
};

var fetchFuncNameFromVerb = function fetchFuncNameFromVerb(verb) {
  return camelCase(verb) + 'Func';
};
var renameVerbFuncs = renameBy(fetchFuncNameFromVerb);

function makeFetchFunc(endpoint, verb) {
  var url = getUrl(endpoint, verb);
  var options = getMakeOptions(endpoint, verb);
  var fetchImplementation = endpoint.fetchFunc || fetch;
  return function () {
    return fetchImplementation(typeof url === 'function' ? url.apply(undefined, arguments) : url, options.apply(undefined, arguments));
  };
}

// we can derive an action from an Endpoint object and an HTTP verb
// this returns an object containing the derived REST action (which
// is an async action suitable for use with redux-thunk), and all the
// derived action types.
var deriveAction = function deriveAction(endpoint, verb) {
  var prefix = getPrefixForEndpoint(verb, endpoint);

  var requestType = requestActionType(prefix, endpoint.name);
  var successType = successActionType(prefix, endpoint.name);
  var failureType = failureActionType(prefix, endpoint.name);

  var createActionFunc = endpoint.namespaceOnUsername ? withUsername : reduxActions.createAction;

  var requestAction = createActionFunc(requestType);
  var successAction = createActionFunc(successType);
  var failureAction = createActionFunc(failureType);

  var fetchFunc = R.propOr(makeFetchFunc(endpoint, verb), fetchFuncNameFromVerb(verb), endpoint);

  return {
    action: function action() {
      for (var _len5 = arguments.length, params = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        params[_key5] = arguments[_key5];
      }

      return function (dispatch) {
        dispatch(requestAction.apply(undefined, params));
        return fetchFunc.apply(undefined, params).then(function (data) {
          if (endpoint.namespaceOnUsername) {
            // params[0] is the username, in this case
            dispatch(successAction(params[0], data));
          } else {
            dispatch(successAction(data));
          }
          return _Promise.resolve(data);
        }, function (error) {
          if (endpoint.namespaceOnUsername) {
            dispatch(failureAction(params[0], error));
          } else {
            dispatch(failureAction(error));
          }
          return _Promise.reject(error);
        });
      };
    },
    requestType: requestType,
    successType: successType,
    failureType: failureType
  };
};

// here we loop through the HTTP verbs that an Endpoint implements, and
// for each one we derive an action. The derived action types are stuck on
// the function object, as a convenience.
var deriveActions = function deriveActions(endpoint) {
  var actions = {};
  endpoint.verbs.forEach(function (verb) {
    var _deriveAction = deriveAction(endpoint, verb),
        action = _deriveAction.action,
        requestType = _deriveAction.requestType,
        successType = _deriveAction.successType,
        failureType = _deriveAction.failureType;

    var lverb = camelCase(verb);

    actions[lverb] = action;
    actions[lverb].requestType = requestType;
    actions[lverb].successType = successType;
    actions[lverb].failureType = failureType;
  });
  var clearType = clearActionType(endpoint.name);
  actions.clearType = clearType;
  if (endpoint.namespaceOnUsername) {
    actions.clear = withUsername(clearType);
  } else {
    actions.clear = reduxActions.createAction(clearType);
  }
  return actions;
};

// a reducer may be derived on the basis of an Endpoint object, an already
// derived REST action, and an HTTP verb
// A reducer, in this case, is an Object<type, Function>, where type is an
// action type defined on the previously derived action, and the Function has
// the type State -> Action -> State
//
// so the type of the function overall could be rendered
// deriveReducer :: Endpoint -> Action -> String -> Object String (State -> Action -> State)
var deriveReducer = function deriveReducer(endpoint, action, verb) {
  var _ref;

  var fetchStatus = camelCase(verb) + 'Status';

  var successHandler = R.propOr(R.identity, camelCase(verb) + 'SuccessHandler', endpoint);

  var updateFunc = function updateFunc(state, action, update) {
    if (endpoint.namespaceOnUsername) {
      return updateStateByUsername(state, action.meta, _extends({}, endpoint.usernameInitialState, update));
    } else {
      return _extends({}, state, update);
    }
  };

  return _ref = {}, _defineProperty(_ref, action.requestType, function (state, action) {
    var _updateFunc;

    return updateFunc(state, action, (_updateFunc = {}, _defineProperty(_updateFunc, fetchStatus, FETCH_PROCESSING), _defineProperty(_updateFunc, 'loaded', false), _defineProperty(_updateFunc, 'processing', endpoint.checkNoSpinner ? action.payload : true), _updateFunc));
  }), _defineProperty(_ref, action.successType, function (state, action) {
    var _updateFunc2;

    return updateFunc(state, action, (_updateFunc2 = {}, _defineProperty(_updateFunc2, fetchStatus, FETCH_SUCCESS), _defineProperty(_updateFunc2, 'data', successHandler(action.payload, state.data)), _defineProperty(_updateFunc2, 'loaded', true), _defineProperty(_updateFunc2, 'processing', false), _updateFunc2));
  }), _defineProperty(_ref, action.failureType, function (state, action) {
    var _updateFunc3;

    return updateFunc(state, action, (_updateFunc3 = {}, _defineProperty(_updateFunc3, fetchStatus, FETCH_FAILURE), _defineProperty(_updateFunc3, 'error', action.payload), _defineProperty(_updateFunc3, 'loaded', true), _defineProperty(_updateFunc3, 'processing', false), _updateFunc3));
  }), _ref;
};

var deriveReducers = function deriveReducers(endpoint, actions) {
  var initialState = R.propOr(INITIAL_STATE, 'initialState', endpoint);

  var reducers = R.reduce(R.merge, {}, [].concat(_toConsumableArray(endpoint.verbs.map(function (verb) {
    return deriveReducer(endpoint, actions[camelCase(verb)], verb);
  })), [R.propOr({}, 'extraActions', endpoint), _defineProperty({}, actions.clearType, function () {
    return initialState;
  })]));

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    return R.has(action.type, reducers) ? reducers[action.type](state, action) : state;
  };
};

var deriveVerbFuncs = function deriveVerbFuncs(verbFuncs) {
  return _extends({
    verbs: R.keys(verbFuncs)
  }, renameVerbFuncs(verbFuncs));
};

exports.requestActionType = requestActionType;
exports.successActionType = successActionType;
exports.failureActionType = failureActionType;
exports.clearActionType = clearActionType;
exports.makeFetchFunc = makeFetchFunc;
exports.deriveAction = deriveAction;
exports.deriveActions = deriveActions;
exports.deriveReducer = deriveReducer;
exports.deriveReducers = deriveReducers;
exports.deriveVerbFuncs = deriveVerbFuncs;
